export default __webpack_public_path__ + "static/media/m-11.106624ec.svg";